import { useIntl } from '@/intl'
import { getCardImageProps } from '@/scopes/account/bookings-overview/pages/utils/getCardImageProps'
import { Card } from '@sunwebgroup/uds-ui/card'
import { Sheet } from '@sunwebgroup/ui-components/uds'
import { useBookingsOverviewStore } from '../../infrastructure/useBookingsOverviewStore'
import { getSortedUpcomingBookings } from '../selectors'
import styles from './SelectBookingSheet.module.css'

export function SelectBookingSheet() {
  const intl = useIntl()
  const upcomingBookings = useBookingsOverviewStore(getSortedUpcomingBookings)
  const selectedBookingNumber = useBookingsOverviewStore(state => state.selectedUpcomingBookingId)
  const isUpcomingBookingSheetOpen = useBookingsOverviewStore(state => state.isUpcomingBookingSheetOpen)
  const setIn = useBookingsOverviewStore(state => state.setIn)

  const handleBookingSelect = (bookingNumber: string) => {
    setIn('selectedUpcomingBookingId', bookingNumber)
    setIn('isUpcomingBookingSheetOpen', false)
  }

  return (
    <Sheet.Root
      open={isUpcomingBookingSheetOpen}
      onOpenChange={(open) => { setIn('isUpcomingBookingSheetOpen', open) }}
    >
      <Sheet.Body side="right">
        <Sheet.Header titleLabel={intl.formatMessage({ id: 'bookings_overview_select_booking_title' })} closeLabel={intl.formatMessage({ id: 'close' })} />
        <Sheet.Content>
          <div className={styles.contentContainer} role="listbox" aria-label={intl.formatMessage({ id: 'bookings_overview_select_booking_title' })}>
            {upcomingBookings.length > 0 && (
              upcomingBookings.map((booking) => {
                const {
                  mediaSrc,
                  mediaPlaceholderSrc,
                } = getCardImageProps(booking.imageSrc)

                return (
                  <Card
                    key={booking.bookingNumber}
                    title={booking.accommodationName}
                    subtitle={booking.destination}
                    date={booking.period}
                    mediaSrc={mediaSrc}
                    mediaPlaceholderSrc={mediaPlaceholderSrc}
                    onClick={() => handleBookingSelect(booking.bookingNumber)}
                    className={selectedBookingNumber === booking.bookingNumber ? styles.cardSelected : undefined}
                    role="option"
                    aria-selected={selectedBookingNumber === booking.bookingNumber}
                  />
                )
              })
            )}
          </div>
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
